import { useState, useEffect } from "react";
import axios from "../api/axios";
import useAxiosFunction from "./useAxiosFunction";

export default function useJobAdvert(id) {

    const [jobAdvert, setJobAdvert] = useState(null);

    const [error, setError] = useState(null);

    const [loading, setLoading] = useState(true);

    const [, , , axiosFetch] = useAxiosFunction();

    useEffect(() => {

        if (!id) {
            return;
        }

        const loadJobAdvert = async () => {

            try {

                setLoading(true);
                const requestUrl = `/job-adverts/${id}`;
                console.log("Axios Base URL:", axios.defaults.baseURL);
                console.log("Axios Request URL:", requestUrl);

                const data = await axiosFetch({

                    axiosInstance: axios,

                    method: "get",

                    url: `/job-adverts/${id}`

                });

                setJobAdvert(data);

            } catch (err) {

                console.log(err);

                setError(err);

            } finally {

                setLoading(false);

            }

        };

        loadJobAdvert();

    }, [id]);

    return {

        jobAdvert,

        loading,

        error

    };

}